import { useCallback } from "react";
import { Api, deleteToken, getSessionTokenFromLocalStorage } from '../../module/api/index';
import { useNavigate } from 'react-router-dom';
import { RoutingPath } from '../../routes/routing-path';
import { AxiosError } from 'axios';
import RootStore from '../../store/root.store';

export const DIALOG_401_ID = '401error';

export const useAuth = () => {
  const navigator = useNavigate();

  const logout = useCallback(async() => {
    // ログアウト処理→ログインページに遷移
    try {
      await Api.connect().logout().post();
    } catch(e) {
    } finally {
      RootStore.user.destroy();
      deleteToken();
      navigator(RoutingPath.login);
    }
  }, [navigator]);

  const checkLogin = useCallback(async(ignoreCheckToken?: boolean) => {
    if (ignoreCheckToken && RootStore.dialog.includesId(DIALOG_401_ID)) {
      return;
    }
    const token = getSessionTokenFromLocalStorage();
    if (!token) {
      navigator(RoutingPath.login);
      return;
    };
    try {
      const isLoginResponse = await Api.connect().isLogin().get();
      // 初回ログイン時のパスワード変更が未完了のままセッションが継続している想定外の状態のため、
      // ログアウトさせてログイン画面からやり直させる
      if (isLoginResponse.data.company.password_change_required_flag) {
        await logout();
        return;
      }
      RootStore.user.setUser(isLoginResponse.data);
    } catch(e: any) {
      const error = e as AxiosError<any>;
      deleteToken();
      if (error?.response?.status !== 401) {
        navigator(RoutingPath.login)
      } else {
        RootStore.dialog.pushMessage({
          id: DIALOG_401_ID,
          messages: ['セッションが切断されました。', 'ログインページに戻ります。'],
          buttons: [
            { label: 'OK', callback: () => navigator(RoutingPath.login) }
          ]
        })
      }
    }
  }, [navigator, logout]);

  return {
    checkLogin,
    logout,
  }
}
